module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_concept_02-7e4ecdcfa862e5f94485dea33ca0885f.jpg";